webpackJsonp([70144966829960],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    { className: "ContentsContainer Services" },
	    _react2.default.createElement(
	      "h1",
	      null,
	      "\xBF Hablamos ?"
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "intro" },
	      "Comun\xEDcate con nosotros.",
	      _react2.default.createElement(
	        "a",
	        { href: "tel:+573005215073" },
	        " 3005215073"
	      )
	    ),
	    _react2.default.createElement(
	      "form",
	      { className: "Form", name: "contact", method: "post", netlify: true },
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement("input", { type: "text", name: "name", placeholder: "Nombres" })
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement("input", { type: "email", name: "email", placeholder: "Email" })
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement("input", { type: "phone", name: "phone", placeholder: "Tel\xE9fono" })
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement("textarea", { name: "message", placeholder: "Mensaje" })
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          "button",
	          { type: "submit" },
	          "Enviar"
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-ddba6f26d46070b367b8.js